import { render } from "./CheckoutTicketCard.vue?vue&type=template&id=b8a87502&scoped=true"
import script from "./CheckoutTicketCard.vue?vue&type=script&lang=js"
export * from "./CheckoutTicketCard.vue?vue&type=script&lang=js"

import "./CheckoutTicketCard.vue?vue&type=style&index=0&id=b8a87502&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a87502"]])

export default __exports__